
export type Frequency = "M" | "W" | "F" | "4W" | "Q" | "A";

type MultiplierItem = {
    frequency: Frequency;
    value: number;
}

export const monthlyMultiplier = (item: MultiplierItem) => {
  switch (item.frequency) {
    case "M":
      return item.value;
    case "W":
      return (item.value * 52) / 12;
    case "F":
      return (item.value * 26) / 12;
    case "4W":
      return (item.value * 13) / 12;
    case "Q":
      return (item.value * 4.33333) / 12;
    case "A":
      return item.value / 12;
    default:
      return item.value ?? 0;
  }
};
